'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "HeaderHeightContext", {
    enumerable: true,
    get: function() {
        return HeaderHeightContext;
    }
});
const _getNamedContext = require("../getNamedContext");
const HeaderHeightContext = (0, _getNamedContext.getNamedContext)('HeaderHeightContext', undefined);

//# sourceMappingURL=HeaderHeightContext.js.map
